import { FunctionComponent } from "react";
import TopNav from "../../components/navigation/TopNav";
import Footer from "../../components/website/Footer";
import MobileNav from "../../components/navigation/MobileNav";
import TrustedPartnerApplicationForm from "../../components/forms/TrustedPartnerApplicationForm";


const TrustedPartnerApplication: FunctionComponent = () => {
    return (
        <div className="max-w-[1440px] mx-auto w-full">
            <TopNav />
            <MobileNav />
            
            <main className="min-h-screen bg-gray-50 py-12">
                <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
                    <TrustedPartnerApplicationForm />
                </div>
            </main>
            
            <Footer />
        </div>
    );
};


export default TrustedPartnerApplication;


